module.exports = __webpack_public_path__ + "static/media/Fortune-clip.687ac237.mov";